<template>
	<div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-5 w-full lg:w-auto">
		<div
			class="flex items-center text-slate-700"
			:class="{
				'text-xl': textSize !== 'big',
				'text-xl lg:text-3xl': textSize === 'big',
				'justify-start': textPosition !== 'right',
				'justify-end': textPosition === 'right',
			}">
			<p v-if="slots.icon" class="mr-3">
				<slot name="icon"></slot>
			</p>
			<div class="font-medium text-center lg:text-left flex flex-wrap items-center gap-4 w-full">
				<slot name="text"></slot>
			</div>
		</div>
		<div v-if="slots.actions" class="order-first flex justify-end items-center relative gap-5 sm:order-none">
			<slot name="actions"></slot>
		</div>
	</div>
</template>

<script setup>
	import { useSlots } from 'vue';

	const slots = useSlots();

	const props = defineProps({
		textSize: {
			type: String,
			default: 'normal',
			validator: (value) => ['normal', 'big'].includes(value),
		},
		textPosition: {
			type: String,
			default: 'left',
			validator: (value) => ['left', 'right'].includes(value),
		},
	});
</script>
